import i18next from "i18next";
import { toNumber, toString } from "lodash";
import { AccountDetector, LocalesType } from "../constants/globals";
import * as STORAGE_KEYS from "../constants/localstorage";
import { QR_CODE_NEW_DEVICE, USER_DELETE, USER_LOGIN, USER_REGISTER, USER_SESSION_LOGOUT } from "../constants/methods";
import { Language } from "../proto/Global_pb";
import { agentBrowserName, agentBrowserVersion, agentDevice, agentPlatform } from "./agent";
import Client from "./Api/Client";
import { protoHandler } from "./proto";
import { clearStorages, delStorage, getStorage, hasStorage, setStorage } from "./storage";
import { randomString, stringToUint8Array } from "./utils";
import { ROUTE_LOGIN, ROUTE_LOGIN_CODE } from "../constants/routes";
import MultiAccount from "./multiAccount";
import { memoryHistory } from "../index";
import Metrix from "./metrix";
import { METRIX_ACTIVE_CODE, METRIX_QR_ACTIVATION } from "../constants/events";
import { base64Prefix } from "./file";
import { QrCodeNewDeviceResponse } from "../proto/QrCodeNewDevice_pb";
import { ErrorResponse } from "../proto/Error_pb";
import { UserRegister, UserRegisterResponse } from "../proto/UserRegister_pb";
import { InfoLocationResponse } from "../proto/InfoLocation_pb";
import { InfoCountry, InfoCountryResponse } from "../proto/InfoCountry_pb";
import MockSocketClient from "./Api/client-mock";

const storageUsersKey=[
    STORAGE_KEYS.STORAGE_USER_ID,
    STORAGE_KEYS.STORAGE_NOTIFICATION_OPTION,
    STORAGE_KEYS.STORAGE_AUTHOR_HASH,
    STORAGE_KEYS.STORAGE_TOKEN,
    STORAGE_KEYS.STORAGE_SET_ACTION_ID,
    STORAGE_KEYS.STORAGE_ACTIVE_INDEX_GALLERY,
]

export const checkAuth = (): boolean => {
  return hasStorage(STORAGE_KEYS.STORAGE_USER_ID) && hasStorage(STORAGE_KEYS.STORAGE_AUTHOR_HASH) && hasStorage(STORAGE_KEYS.STORAGE_TOKEN);
};

export const register = (params: Partial<UserRegister.AsObject> & { infoCountry: InfoLocationResponse.AsObject & InfoCountryResponse.AsObject }): Promise<void> => {
  Metrix.sendEvent(METRIX_ACTIVE_CODE);
  return protoHandler(USER_REGISTER, {
    phoneNumber: params?.phoneNumber,
    countryCode: params.countryCode,
    preferenceMethod: params.preferenceMethod,
    appId: toNumber(process.env.REACT_APP_ID!),
  }).then((userRegisterResponse) => {
    goToLoginCodePage({
      protoInfoCountry: params.infoCountry,
      protoInfoLocation: params.infoCountry,
      protoUserRegister: userRegisterResponse,
      appTemporaryLoginPhone: params.phoneNumber!,
      userId: userRegisterResponse.userId,
      authorHash: userRegisterResponse.authorHash,
    });
  });
};

export const logIn = (): void => {
  let symmetricKey = window.Cypress ? stringToUint8Array(randomString(32)) : stringToUint8Array(Client.instance.getSymmetricKey!);
  protoHandler(USER_LOGIN, {
    token: getStorage(STORAGE_KEYS.STORAGE_TOKEN),
    appName: process.env.REACT_APP_NAME!,
    appId: toNumber(process.env.REACT_APP_ID!),
    appBuildVersion: toNumber(process.env.REACT_APP_BUILD_VERSION!),
    appVersion: process.env.REACT_APP_VERSION!,
    platform: agentPlatform(),
    platformVersion: agentBrowserVersion(),
    device: agentDevice(),
    deviceName: agentBrowserName(),
    language: i18next.language === LocalesType["FA"] ? Language["FA_IR"] : Language["EN_US"],
    symmetricKey,
  }).catch((e) => {
    console.error(e);
    console.error("SOCKET CLOSED FROM auth.ts logIn");
    Client.instance.close();
  });
};

export const logOut = async (): Promise<void> => {
    const currentAccount = await getStorage(STORAGE_KEYS.STORAGE_USER_PREF, false);
    const availableAccounts = MultiAccount.availableAccounts().filter((item) => {
        return item !== currentAccount;
    });

 storageUsersKey.map(item=>{delStorage(item,true)})

    if (availableAccounts.length) await setStorage(STORAGE_KEYS.STORAGE_USER_PREF, availableAccounts[0], false, false);
    await protoHandler(USER_SESSION_LOGOUT, {}).then();
    await window.location.reload();
};

export const deleteAccount = async (token: string): Promise<void> => {
  protoHandler(USER_DELETE, { token }).then(() => {
    clearStorages();
    memoryHistory.push(ROUTE_LOGIN);
  });
};

export const loginWithQr = (): Promise<string> => {
  return protoHandler(QR_CODE_NEW_DEVICE, {
    appBuildVersion: toNumber(process.env.REACT_APP_BUILD_VERSION!),
    appId: toNumber(process.env.REACT_APP_ID!),
    appName: process.env.REACT_APP_NAME!,
    appVersion: process.env.REACT_APP_VERSION!,
    device: agentDevice(),
    deviceName: agentBrowserName(),
    platform: agentPlatform(),
    platformVersion: agentBrowserVersion(),
  }).then((qrCodeNewDeviceResponse) => {
    Metrix.sendEvent(METRIX_QR_ACTIVATION);
    return base64Prefix(toString(qrCodeNewDeviceResponse?.qrCodeImage));
  });
};

export const goToLoginCodePage = (params: {
  protoInfoCountry: InfoLocationResponse.AsObject;
  protoInfoLocation: InfoLocationResponse.AsObject;
  protoUserRegister: UserRegisterResponse.AsObject;
  appTemporaryLoginPhone: string;
  userId: UserRegisterResponse.AsObject["userId"];
  authorHash: UserRegisterResponse.AsObject["authorHash"];
}) => memoryHistory.push(ROUTE_LOGIN_CODE, params);
